import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React from 'react';

import { ButtonV2, Col, Cols, usePublicaTranslation } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

// this component is used to check if the user wants to include creatives when cloning an order
export interface IModalDialogCustomConfirmationProps {
  active: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  confirmationMessage: string;
  item: string;
}

export const ModalDialogCustomConfirmationView = ({
  active,
  onConfirm,
  onCancel,
  confirmationMessage,
  item,
}: IModalDialogCustomConfirmationProps): React.JSX.Element => {
  const { t } = usePublicaTranslation();

  return (
    <Dialog
      open={active}
      onClose={onCancel}
      disableEscapeKeyDown={false}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle>{t('ConfirmSaveItem', { item: t('PremiumFeatures') })}</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ color: publicaColors.black }}>
          {confirmationMessage}
        </DialogContentText>
        <DialogContentText style={{ color: publicaColors.black, fontWeight: '500' }}>
          {t('ModalConfirmationUpdateItemText', { item })}
        </DialogContentText>
        <Cols noPadding style={{ justifyContent: 'flex-end', alignItems: 'end' }}>
          <Col>
            <DialogActions>
              <ButtonV2 small onClick={onConfirm}>
                {t('ConfirmAndSave')}
              </ButtonV2>
            </DialogActions>
          </Col>
          <Col>
            <DialogActions>
              <ButtonV2 small onClick={onCancel}>
                {t('Cancel')}
              </ButtonV2>
            </DialogActions>
          </Col>
        </Cols>
      </DialogContent>
    </Dialog>
  );
};
